import dxNotify from 'devextreme/ui/notify'

export default function notify(messageOrOptions: string | any, type?: string, displayTime: number = 3000): void {
	dxNotify(messageOrOptions, type, displayTime)
}
